var cov_c2hdkspm2 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/index.ts",
      hash = "908c71fe4b387e72f7af9040d5ce44fd9a4ab427",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Slider/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 15
        },
        end: {
          line: 5,
          column: 35
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 37
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import Container from './Container';
var Slider = (cov_c2hdkspm2.s[0]++, inputable(Container));
cov_c2hdkspm2.s[1]++;
Slider.displayName = 'ShineoutSlider';
export default Slider;